module.exports = __webpack_public_path__ + "static/media/sb.a6d8611d.svg";